"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statistics = require("@/api/statistics");
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProductStatistics',
  data: function data() {
    return {
      loading: false,
      sourceMap: {
        h5: 'H5',
        mini: '小程序'
      },
      userSourceMap: {
        1: 'WiFi',
        2: '摄像头'
      },
      queryParams: {
        dateRange: [(0, _dayjs.default)().format('YYYY-MM-DD'), (0, _dayjs.default)().format('YYYY-MM-DD')],
        page: 1,
        limit: 20,
        productId: '',
        source: '',
        userSource: ''
      },
      summaryList: [],
      orderList: [],
      total: 0
    };
  },
  created: function created() {
    this.getList();
    this.getSummary();
  },
  methods: {
    getList: function getList() {
      var _this$queryParams,
        _this = this;
      this.loading = true;
      var _ref = ((_this$queryParams = this.queryParams) === null || _this$queryParams === void 0 ? void 0 : _this$queryParams.dateRange) || [],
        _ref2 = _slicedToArray(_ref, 2),
        startDate = _ref2[0],
        endDate = _ref2[1];
      var params = {
        startDate: startDate || (0, _dayjs.default)().format('YYYY-MM-DD'),
        endDate: endDate || (0, _dayjs.default)().format('YYYY-MM-DD'),
        page: this.queryParams.page,
        limit: this.queryParams.limit,
        productId: this.queryParams.productId,
        source: this.queryParams.source,
        userSource: this.queryParams.userSource
      };
      (0, _statistics.statisticsListApi)(params).then(function (res) {
        _this.orderList = res.list || [];
        _this.total = res.total || 0;
        // 默认按PV从大到小排序
        _this.orderList.sort(function (a, b) {
          return parseFloat(b.pv) - parseFloat(a.pv);
        });
      }).catch(function (error) {
        console.error('获取列表失败：', error);
        _this.$message.error('获取列表失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    getSummary: function getSummary() {
      var _this$queryParams2,
        _this2 = this;
      var _ref3 = ((_this$queryParams2 = this.queryParams) === null || _this$queryParams2 === void 0 ? void 0 : _this$queryParams2.dateRange) || [],
        _ref4 = _slicedToArray(_ref3, 2),
        startDate = _ref4[0],
        endDate = _ref4[1];
      var params = {
        startDate: startDate || (0, _dayjs.default)().format('YYYY-MM-DD'),
        endDate: endDate || (0, _dayjs.default)().format('YYYY-MM-DD')
      };
      (0, _statistics.statisticsSummaryApi)(params).then(function (res) {
        _this2.summaryList = (res || []).map(function (item) {
          return {
            source: item.source,
            uv: item.totalUv,
            orderCount: item.totalOrderCount,
            paidOrderCount: item.totalPaidOrderCount,
            orderRate: item.orderRate,
            payRate: item.payRate,
            orderAmount: item.totalOrderAmount,
            paidAmount: item.totalPaidAmount,
            profitPerUv: item.averagePerCustomer
          };
        });
        console.log(_this2.summaryList);
      }).catch(function (error) {
        console.error('获取汇总数据失败：', error);
        _this2.$message.error('获取汇总数据失败');
      });
    },
    handleQuery: function handleQuery() {
      this.getList();
      this.getSummary();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        dateRange: [(0, _dayjs.default)().format('YYYY-MM-DD'), (0, _dayjs.default)().format('YYYY-MM-DD')],
        page: 1,
        limit: 20,
        productId: '',
        source: '',
        userSource: ''
      };
      this.handleQuery();
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      console.log(data);
      var sums = [];
      var idxMap = {
        uv: -1,
        orderCount: -1,
        paidOrderCount: -1,
        orderRate: -1,
        payRate: -1
      };
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (typeof idxMap[column.property] !== 'undefined') {
          idxMap[column.property] = index;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (['orderRate', 'payRate'].includes(column.property)) {
            sums[index] = sums[index].toFixed(2) + '%';
          } else if (['orderAmount', 'paidAmount', 'cost', 'profit', 'profitPerUv'].includes(column.property)) {
            sums[index] = '¥' + sums[index].toFixed(2);
          }
        } else {
          sums[index] = '--';
        }
      });
      sums[idxMap.orderRate] = sums[idxMap.uv] ? (sums[idxMap.orderCount] / sums[idxMap.uv] * 100).toFixed(2) + '%' : '--';
      sums[idxMap.payRate] = sums[idxMap.orderCount] ? (sums[idxMap.paidOrderCount] / sums[idxMap.orderCount] * 100).toFixed(2) + '%' : '--';
      return sums;
    },
    // 排序事件处理
    handleSortChange: function handleSortChange(_ref5) {
      var prop = _ref5.prop,
        order = _ref5.order;
      // 所有可以排序的数字类型字段
      var numberFields = ['pv', 'uv', 'orderCount', 'paidOrderCount', 'orderRate', 'payRate', 'paidAmount', 'cost', 'profit', 'profitPerUv'];
      if (numberFields.includes(prop)) {
        this.orderList.sort(function (a, b) {
          var aValue = parseFloat(a[prop]);
          var bValue = parseFloat(b[prop]);
          return order === 'ascending' ? aValue - bValue : bValue - aValue;
        });
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    }
  }
};